<template>
  <div>
    <b-modal
      v-model="showModal"
      centered
      header-class="custom-modal-header"
      footer-class="custom-modal-footer"
      id="modal-export"
    >
      <template #modal-header> Export File </template>
      <div class="modal-export">
        <InputText
          v-model="email"
          textFloat="Email"
          placeholder="Email"
          type="email"
          name="email"
          isRequired
          :isValidate="$v.email.$error"
          :v="$v.email"
        />
      </div>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between">
          <button class="cancel-button" @click="hide">Cancel</button>
          <button class="save-button" @click="confirmEmail">Confirm</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import InputText from "@/components/inputs/InputText";

export default {
  components: {
    InputText,
  },
  data() {
    return {
      email: "",
      checkAll: false,
      showModal: false,
      isLoading: false,
    };
  },
  validations() {
    return {
      email: { required, email },
    };
  },
  computed: {
    ...mapGetters(["getUserDetail"]),
  },
  watch: {
    showModal(val) {
      if (!val) {
        this.$v.email.$reset();
        this.email = "";
        this.checkAll = false;
      }
    },
  },
  methods: {
    show() {
      this.email = this.getUserDetail().email;
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    confirmEmail() {
      this.$v.email.$touch();

      if (this.$v.email.$error) return;

      let response = {
        email: this.email,
        // is_take_all: this.checkAll,
      };

      this.isLoading = true;
      this.$emit("confirmEmail", response);
    },
  },
};
</script>

<style lang="scss" scoped></style>
